import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { appInvoicesApi } from "../../services/api";

export const getInvoices = createAsyncThunk("invoice/getInvoices", async () => {
  try {
    const data = await appInvoicesApi.getInvoices();
    if (data.success) {
      return data.invoices;
    }
    return [];
  } catch (error) {
    console.error("Error fetching invoices:", error);
    return [];
  }
});

export const addNewInvoice = createAsyncThunk("invoice/addNewInvoice", async (invoice: any) => {
  try {
    const data = await appInvoicesApi.createInvoice({
      userId: invoice.user_id,
      items: invoice.items,
      dueDate: invoice.due_date,
      notes: invoice.notes,
      billingName: invoice.billing_name,
      billingEmail: invoice.billing_email,
      billingAddress: invoice.billing_address
    });
    if (data.success) {
      toast.success("Invoice Added Successfully", { autoClose: 3000 });
      return { ...invoice, id: data.id, invoiceNumber: data.invoiceNumber };
    }
    throw new Error("Failed to add invoice");
  } catch (error) {
    toast.error("Invoice Added Failed", { autoClose: 3000 });
    return error;
  }
});

export const updateInvoice = createAsyncThunk("invoice/updateInvoice", async (invoice: any) => {
  try {
    const data = await appInvoicesApi.updateInvoiceStatus(invoice.id, invoice.status);
    if (data.success) {
      toast.success("Invoice Updated Successfully", { autoClose: 3000 });
      return invoice;
    }
    throw new Error("Failed to update invoice");
  } catch (error) {
    toast.error("Invoice Updated Failed", { autoClose: 3000 });
    return error;
  }
});

export const deleteInvoice = createAsyncThunk("invoice/deleteInvoice", async (invoice: any) => {
  try {
    // Note: Delete endpoint not implemented in backend yet
    // For now, just mark as cancelled
    const data = await appInvoicesApi.cancelInvoice(invoice);
    if (data.success) {
      toast.success("Invoice Cancelled Successfully", { autoClose: 3000 });
      return { invoice };
    }
    throw new Error("Failed to delete invoice");
  } catch (error) {
    toast.error("Invoice Delete Failed", { autoClose: 3000 });
    return error;
  }
});
